import BaseObjectStore from './base-object.store';

class AcwrReadinessStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'acwrScore';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new AcwrReadinessStore();
